"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeContextType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function cov_1y7xbtulu4() {
  var path = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/type.js";
  var hash = "03fcc8f4a0cde66cc9990ad91fafe4e97bc7b094";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/type.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 25
        },
        end: {
          line: 7,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "03fcc8f4a0cde66cc9990ad91fafe4e97bc7b094"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1y7xbtulu4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1y7xbtulu4();
/* eslint-disable import/prefer-default-export */
var ThemeContextType = exports.ThemeContextType = (cov_1y7xbtulu4().s[0]++, _propTypes.default.shape({
  theme: _propTypes.default.string,
  variables: _propTypes.default.object
}));